<template>
  <div>
    <!-- SVG Sprites cachés -->
    <SvgSprites />
    <!-- Router view principal -->
    <router-view />
  </div>
</template>

<script setup lang="ts">
import SvgSprites from '@/components/layout/seller/SvgSprites.vue';

// Plus de logique de vérification du token
// Tout est maintenant géré côté serveur via cookies HttpOnly
</script>

<style lang="scss" scoped>
</style> 